import {HttpClient} from '@angular/common/http'
import {inject, Service} from '@angular/core'
import {Observable} from 'rxjs'
import {environment} from '../../environments/environment'

export interface Consumed {
  sub: string
  timeStamp: number
}

export interface RequestListItem {
  personNummer: string
  sub: string
  consumed: Consumed[]
  timeStamp: number
  ref: string
  documentation: string
}

@Service()

export class AdminService {
  private readonly http = inject(HttpClient)

  public getRequests(): Observable<RequestListItem[]> {
    const url = `${environment.dataServiceUrl}/admin/requests`
    return this.http.get<RequestListItem[]>(url)
  }
}
